var link_viewer_default = {
  "fontElementMap": "bk6zO",
  "link": "WUCMP",
  "linkInEditor": "bHehz",
  "linkInViewer": "GjqyF",
  "toolbarUrlContainer": "_35Le0",
  "toolbarUrl": "LB2BR",
  "toolbarUrlAnchor": "kkgc8"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
